/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-useless-escape */

// フリガナのバリデーションを行う
export const validateFurigana = (target: string): boolean =>
  target.match(/^[ァ-ヶー　]+$/)?.length !== 1;
